export { TruncatePipeModule } from './truncate.pipe.module';
export { TruncatePipe } from './truncate.pipe';
